export default __webpack_public_path__ + "static/media/3A5FF87E-B327-4C3F-ACD5-E72FF670D6EC.b1972d50.jpeg";